/**
 * Which deployment the app is running in, derived from the host's domain suffix.
 *
 * Suffix rather than exact host: the custom build is served from a NextGen custom domain
 * (e.g. ujjivan.crm4b2c.com/fieldsales), so the fs-dashboard-* hostnames these lookups used to
 * match no longer appear. The suffix still identifies the environment because NextGen's domains
 * follow the same per-environment convention as ours.
 *
 * Region is one value per environment because FieldSales runs a single deployment per environment.
 * If that ever stops being true, region has to come from config, not from the hostname.
 */
const DEPLOYMENTS = [
  { suffix: 'marketxpander.net', env: 'dev', region: 'us-east-1' },
  { suffix: 'crm4b2c.com', env: 'test', region: 'ap-southeast-1' },
  { suffix: 'lsq-staging.com', env: 'stage', region: 'ap-south-1' },
  { suffix: 'leadsquared.com', env: 'prod', region: 'ap-south-1' }
];

const UNKNOWN = { env: 'local', region: 'local' };

export const getDeployment = (host = window.location.host) => {
  if (!host) {
    return UNKNOWN;
  }

  const match = DEPLOYMENTS.find((deployment) => host.endsWith(deployment.suffix));
  return match ? { env: match.env, region: match.region } : UNKNOWN;
};
